import React, { useState, useEffect } from "react";
import Layout from "../components/Layout";
import Card from "../components/Card";
import PageHeader from "../components/PageHeader";
import axios from "axios";

import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import {
  Hourlyapi,
  subDataHourly,
  TrafficApi,
  VisionGamesHourlyapi,
  VisionGamesTrafficApi,
  VisionGamesSubDataHourly,
  DigitizeHourlyApi,
  DigitizeTrafficApi,
  DigitizeSubDataHourly,
  WondermindHourlyApi,
  WondermindTrafficApi,
  WondermindSubDataHourly,
  KickwinHourlyApi,
  KickwinTrafficApi,
  KickwinSubDataHourly,
} from "../Data/api";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { Dropdown } from "primereact/dropdown";

const Hourly = () => {
  const services = [
    { name: "kiddoCraze", code: "KC" },
    { name: "VisionGames", code: "VG" },
    { name: "DigitizeAi", code: "DA" },
    { name: "WonderMind", code: "WM" },
    { name: "KickWin", code: "KW" },
  ];
  const [selectedService, setSelectedService] = useState(services[0]);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [isPaid, setIsPaid] = useState(true);
  const [traffic, setTraffic] = useState([]);
  const formattedDate = moment(selectedDate).format("YYYY-MM-DD");

  const handleToggle = () => {
    setIsPaid(!isPaid);
  };

  // useEffect(() => {
  //   getData();
  // }, [selectedDate, isPaid, selectedService]);

  // useEffect(() => {
  //   getTrafficData();
  // }, [selectedDate, selectedService]);


  useEffect(() => {
  fetchAllData();
}, [selectedDate, isPaid, selectedService]);


  const fetchAllData = async () => {
  setLoading(true);
  setError(null);

  try {
    await Promise.all([
      getData(false),
      getTrafficData()
    ]);
  } catch (err) {
    console.error(err);
  } finally {
    setLoading(false);
  }
};

  const getData = async (showLoading = true) => {
    // if (showLoading) setLoading(true);
    setError(null);

    try {
      let apiUrl, subApiUrl;

      if (selectedService.code === "KC") {
        apiUrl = Hourlyapi;
        subApiUrl = subDataHourly;
      } else if (selectedService.code === "VG") {
        apiUrl = VisionGamesHourlyapi;

        subApiUrl = VisionGamesSubDataHourly;
      } else if (selectedService.code === "DA") {
        apiUrl = DigitizeHourlyApi;

        subApiUrl = DigitizeSubDataHourly;
      } else if (selectedService.code === "WM") {
        apiUrl = WondermindHourlyApi;

        subApiUrl = WondermindSubDataHourly;
      } else if (selectedService.code === "KW") {
        apiUrl = KickwinHourlyApi;

        subApiUrl = KickwinSubDataHourly;
      }

      const formattedDate = moment(selectedDate).format("YYYY-MM-DD");

      let res;
      if (isPaid) {
        res = await axios.post(apiUrl, { date: formattedDate });
      } else {
        res = await axios.post(subApiUrl, { date: formattedDate });
      }

      if (res.data && res.data.result) {
        setData(res.data.result);
      } else {
        setData([]);
      }

      // Fetch Traffic Data
      // const trafficRes = await axios.post(trafficApiUrl, { date: formattedDate });
      // if (trafficRes.data && trafficRes.data.result) {
      //   setTraffic(trafficRes.data.result);
      // }
    } catch (error) {
      setError("Error fetching data. Please try again later.");
      setData([]);
    } 
    finally {
      // if (showLoading) setLoading(false);
    }
  };

  const getTrafficData = async () => {
    try {
      let trafficApiUrl;
      if (selectedService.code === "KC") {
        trafficApiUrl = TrafficApi;
      } else if (selectedService.code === "VG") {
        trafficApiUrl = VisionGamesTrafficApi;
      } else if (selectedService.code === "DA") {
        trafficApiUrl = DigitizeTrafficApi;
      } else if (selectedService.code === "WM") {
        trafficApiUrl = WondermindTrafficApi;
      } else if (selectedService.code === "KW") {
        trafficApiUrl = KickwinTrafficApi;
      }

      const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
      const trafficRes = await axios.post(trafficApiUrl, {
        date: formattedDate,
      });

      if (trafficRes.data && trafficRes.data.result) {
        setTraffic(trafficRes.data.result);
      }
    } catch (error) {
      console.error("Error fetching traffic data:", error);
    }
  };

  // const getTrafficData = async () => {
  //   try {
  //     let trafficApiUrl = selectedService.code === "KC" ? TrafficApi : VisionGamesTrafficApi;
  //     const formattedDate = moment(selectedDate).format("YYYY-MM-DD");
  //     const trafficRes = await axios.post(trafficApiUrl, { date: formattedDate });

  //     if (trafficRes.data && trafficRes.data.result) {
  //       setTraffic(trafficRes.data.result);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching traffic data:", error);
  //   }
  // };

  return (
    <Layout>
      <div className="flex flex-col items-center w-full">
        <div className="w-full px-4">
          <PageHeader title="Hourly Logs" />
        </div>

        <Card className="w-full mb-6 p-5">
          <div className="grid gap-4 lg:grid-cols-[minmax(0,1fr)_auto] items-center">
            <div className="space-y-4">
              <div>
                <p className="text-sm text-slate-500">Selected date</p>
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  timeFormat="HH:mm"
                  timeIntervals={15}
                  dateFormat="yyyy-MM-dd"
                  className="w-full py-3 text-slate-700 border border-slate-300 rounded-2xl shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-transparent transition-colors duration-200 text-center"
                />
              </div>
              <div className="flex flex-col gap-3">
                <p className="text-sm text-slate-500">Selected service</p>
                <div className="rounded-2xl border border-slate-200 bg-slate-50 p-3 shadow-sm">
                  <Dropdown
                    value={selectedService}
                    onChange={(e) => setSelectedService(e.value)}
                    options={services}
                    optionLabel="name"
                    placeholder="Select Service"
                    className="w-full"
                  />
                </div>
              </div>
            </div>
            <div className="flex flex-col items-start gap-3 rounded-3xl border border-slate-200 bg-slate-50 p-4 text-slate-700">
              <p className="text-sm uppercase tracking-[0.2em] text-slate-500">
                Display mode
              </p>
              <button
                onClick={handleToggle}  disabled={loading}
                className={`${isPaid ? "bg-slate-900" : "bg-indigo-600"} text-white font-semibold py-2 px-5 rounded-full transition-colors duration-300`}
              >
                {isPaid ? "REN/PAID" : "SUB"}
              </button>
              <p className="text-sm text-slate-500">
                Showing data for {formattedDate}
              </p>
            </div>
          </div>
        </Card>

        <Card className="w-full mb-6 p-5">
          {/* {error ? ( */}

          {loading ? (
  <div className="flex justify-center items-center py-20">
    <div className="h-12 w-12 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
  </div>
) : error ? (
            <div className="text-center text-lg text-red-500">{error}</div>
          ) : (
            <>
              {isPaid ? (
                <div className="overflow-x-auto">
                  <table className="min-w-full border-collapse border border-slate-200">
                    <thead>
                      <tr className="bg-slate-100">
                        <th className="border border-slate-300 px-4 py-3 text-left">
                          Hour
                        </th>
                        <th className="border border-slate-300 px-4 py-3 text-left">
                          REN
                        </th>
                        <th className="border border-slate-300 px-4 py-3 text-left">
                          SUB
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data.map((item, index) => (
                        <tr key={index} className="hover:bg-slate-100">
                          <td className="border border-slate-300 px-4 py-2">
                            {item.HOUR}
                          </td>
                          <td className="border border-slate-300 px-4 py-2">
                            {item.REN}
                          </td>
                          <td className="border border-slate-300 px-4 py-2">
                            {item.SUB}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="grid gap-6 lg:grid-cols-2">
                  <Card className="p-4">
                    <div className="overflow-x-auto">
                      <table className="min-w-full border-collapse border border-slate-200">
                        <thead>
                          <tr className="bg-slate-100">
                            <th className="border border-slate-300 px-4 py-3 text-left">
                              Hour
                            </th>
                            <th className="border border-slate-300 px-4 py-3 text-left">
                              New-Sub
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {data.map((item, index) => (
                            <tr key={index} className="hover:bg-slate-100">
                              <td className="border border-slate-300 px-4 py-2">
                                {item.HOUR}
                              </td>
                              <td className="border border-slate-300 px-4 py-2">
                                {item.newsub}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card>

                  <Card className="p-4">
                    <div className="overflow-x-auto">
                      <table className="min-w-full border-collapse border border-slate-200">
                        <thead>
                          <tr className="bg-slate-100">
                            <th className="border border-slate-300 px-4 py-3 text-left">
                              Hour
                            </th>
                            <th className="border border-slate-300 px-4 py-3 text-left">
                              Traffic
                            </th>
                            <th className="border border-slate-300 px-4 py-3 text-left">
                              Sent
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {traffic.map((item, index) => (
                            <tr key={index} className="hover:bg-slate-100">
                              <td className="border border-slate-300 px-4 py-2 text-left">
                                {item.HOUR}
                              </td>
                              <td className="border border-slate-300 px-4 py-2 text-left">
                                {item.traffic}
                              </td>
                              <td className="border border-slate-300 px-4 py-2 text-left">
                                {item.sent}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </Card>
                </div>
              )}
            </>
          )}
        </Card>
      </div>
    </Layout>
  );
};

export default Hourly;
